import Element from './../Element';
import UIItem, { ITextData, IImageData } from './../UIItem';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import Interactable from '../../../Component/Interactable';
import SpriteComponent from '../../../Component/Render/Sprite';
import { IRewardData } from '../../../Utility/RewardHelper';
import { StartAnimation } from '../../../System/Animation/AnimationHelper';
import TextComponent from '../../../Component/Render/Text';
import Renderable from '../../../Component/Renderable';
import { IButtonData } from '../BaseElements/Button';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import AnimationComponent from '../../../Component/Animation';

export default class ThreeStarItem extends Element {
    protected _onClick: (index: number) => void;
    protected _reward: IRewardData;
    protected opened: boolean;
    protected index: number;

    public onCreate(params: any): void {
        super.onCreate({
            type: 'group',
            name: `3_star_reward_${params.index}`,
            layout: {
                ...params.layout,
            },
            ...params,
        });
        const basket = UIItem.createButton(this.BasketParams);
        const rewardIcon = UIItem.createImage(this.RewardIconParams);
        const rewardText = UIItem.createText(this.RewardTextParams);

        basket.getComponent(ButtonComponent).onClick = params.onClick;
        rewardIcon.getComponent(Renderable).alpha = 0;
        rewardIcon.addComponent(AnimationComponent);
        rewardIcon.addChild(rewardText);
        basket.addChild(rewardIcon);
        this.addChild(basket);
    }

    public open(): void {
        if (this.opened) return;

        this.opened = true;

        StartAnimation(this, 'ThreeStarRewardWiggle', {
            cacheKey: 'basket_coins',
        });

        this.revealReward();
    }
    public revealReward(): void {
        const rewardIcon: GameObject = this.find(
            `${this.BasketParams.name}/${this.RewardIconParams.name}`
        );

        StartAnimation(rewardIcon, 'ThreeStarRewardTextPopIn', { offset: 135 });
    }
    public set texture(value: string) {
        const basket: GameObject = this.find(this.BasketParams.name);
        basket.getComponent(SpriteComponent).texture = value;
    }
    public set reward(value: IRewardData) {
        if (this._reward !== undefined) return;
        this._reward = value;
        this.getComponentsInChildren(
            TextComponent
        )[0].text = value.value.toString();
    }
    public get reward(): IRewardData {
        return this._reward;
    }
    public get isOpen(): boolean {
        return this.opened;
    }

    protected BasketParams: IButtonData = {
        name: 'basket_icon',
        cacheKey: 'basket_closed',
        layout: {
            anchors: [0, 0, 0, 0],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
    };
    protected RewardIconParams: IImageData = {
        name: 'reward_icon',
        cacheKey: 'coin_pile_with_text',
        layout: {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
    };
    protected RewardTextParams: ITextData = {
        name: 'text',
        textLocalizationKey: '',
        style: {
            font: 'FrancoisOne',
            fontSize: '18px',
            fill: '#ffffff',
        },
        layout: {
            anchors: [0.53, 0.5, 0.53, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
    };
}
